import React, {Component} from 'react';

class DomainUrlRedirect extends Component{
    componentDidMount(){
        const{searchParams, pathname, url} = this.props
        const _url = url.startsWith("http")?url: `http:${url}`;
        let uri = new URL(_url);
        uri.pathname = pathname
        for(const paramName in searchParams){
            uri.searchParams.append(paramName, searchParams[paramName])
        }
        window.location.assign(uri.href)
    }
    render(){
        return(<span data-test-component="DomainUrlRedirect"></span>)
    }
}

export default DomainUrlRedirect


// WEBPACK FOOTER //
// ./src/components/components/functional-skill-card/domain-url-redirect.js